const BASE_URL = process.env.REACT_APP_API_URL || "https://eleccion.ipet50.edu.ar/api/routes";

export default BASE_URL;


//Hostinger: https://eleccion.ipet50.edu.ar/api/routes
//Local: http://localhost:3001

